<template>

    <div id="invoice-index">

        <div class="flex">
            <div class="flex-1 mb-4">
                <h1 class="text-2xl font-medium text-gray-900 capitalize">Invoices</h1>
            </div>

            <div class="flex mb-4 justify-end">
                <router-link :to="{ name: 'place-order' }" class="btn">Place Order</router-link>
            </div>
        </div>

        <OrderIndexFilterBar v-model="indexModel" @submitFilter="indexModel.load()" @resetFilters="indexModel.resetFilters()"></OrderIndexFilterBar>

        <div class="py-4" v-if="indexModel.isLoaded()">

            <div class="index-table" v-if="indexModel.hasResults()">
                <div>
                    <div>
                        <table>
                            <thead>
                                <tr class="flex">
                                    <th scope="col" class="w-2/5 xl:w-2/6 p-3 text-left tracking-wider">
                                        Invoice Number
                                    </th>
                                    <th scope="col" class="w-1/5 xl:w-1/6 p-3 text-center tracking-wider">
                                        Status
                                    </th>
                                    <th scope="col" class="w-1/5 xl:w-1/6 text-center relative p-3">
                                        Net / Gross Total
                                    </th>
                                    <th scope="col" class="w-1/6 hidden xl:table-cell text-right text-right relative p-3">
                                        Invoice Date
                                    </th>
                                    <th scope="col" class="w-1/5 xl:w-1/6 text-right relative p-3">
                                        &nbsp;
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="flex flex-col justify-between overflow-y-scroll w-full max-h-96 xl:max-h-120">
                                <tr class="flex px-2 colored-row" v-for="invoice in indexModel.getData()">
                                    <td class="w-2/5 xl:w-2/6">
                                        <span class="block font-medium">{{ invoice.prefix + invoice.id }}</span>
                                        <span class="text-xs text-gray-400">{{ formatDateShort(invoice.start_date) }} to {{ formatDateShort(invoice.end_date) }}</span>
                                    </td>
                                    <td class="w-1/5 xl:w-1/6 text-center">
                                        <span class="status-box status-complete" v-if="invoice.paid">PAID</span>
                                        <span class="status-box status-cancelled" v-else>NOT PAID</span>
                                    </td>
                                    <td class="w-1/5 xl:w-1/6 text-center">
                                        <span class="block font-medium">{{ formatCurrency(invoice.currency, (invoice.transaction_fee_total + invoice.net_value_total) / 100) }}</span>
                                        <span class="text-sm text-gray-400">{{ formatCurrency(invoice.currency, invoice.gross_value_total / 100) }}</span>
                                    </td>
                                    <td class="xl:w-1/6 hidden xl:table-cell text-right">
                                        <span class="block">{{ formatDateShort(invoice.created_at) }}</span>
                                        <span class="text-xs text-gray-400">{{ invoice.company }}</span>
                                    </td>
                                    <td class="w-1/5 xl:w-1/6 text-center">
                                        <a :href="`/app/download/invoice/${invoice.id}`" class="btn-outline text-xs">Download Invoice</a>
                                    </td>
                                </tr>
                                <tr class="py-6 text-xs font-medium">
                                    <infinite-loading @infinite="infiniteHandler">
                                        <div slot="spinner">Loading...</div>
                                        <div slot="no-more">No more Invoices</div>
                                    </infinite-loading>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="no-results panel" v-else>
                <div class="p-10">
                    <div class="text-gray-200 my-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                    </div>

                    <h2 class="text-gray-600 font-medium text-2xl text-center">No Invoices Available</h2>

                    <p class="text-center mt-4 text-sm text-gray-500">
                        We could not find any invoices, <router-link :to="{ name: 'place-order' }">create an order</router-link>.
                    </p>
                </div>
            </div>

        </div>
        <div class="py-4" v-else-if="indexModel.hasErrorOccurred()">
            <div class="no-results panel p-10">
                <h2 class="font-medium text-error-500">An Error Occurred</h2>

                <p class="mt-4 text-sm">
                    {{ indexModel.getErrorMessage() }}
                </p>
            </div>
        </div>
        <Loading message="Loading Invoices" v-else></Loading>

    </div>

</template>

<script>
import Vue from "vue";
import InfiniteLoading from "vue-infinite-loading";
import {InvoiceIndex} from "../../app/Invoice/InvoiceIndex";
import Loading from "../Support/Loading";
import OrderIndexFilterBar from "./OrderIndexFilterBar";
import {FormattingMixin} from "../../support/mixins";

export default Vue.extend({
    name: "OrderInvoice",
    mixins: [FormattingMixin],
    components: {
        InfiniteLoading,
        OrderIndexFilterBar,
        Loading
    },
    data() {
        return {
            indexModel: new InvoiceIndex
        }
    },
    methods: {
        infiniteHandler($state) {
            this.indexModel.infiniteLoadingHandler($state);
        },
    },
    mounted() {
        this.indexModel.load();
    }
});
</script>
